import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

// import '@ant-design/compatible/assets/index.css';


import { Tabs, Col, Row, Form, DatePicker, Spin } from 'antd';
import Text from 'antd/lib/typography/Text';

import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form';
import { getThirdPartyById } from 'services/thirdParty';
import ParListSelect from 'components/ParListSelect';
//import Form from 'antd/lib/form/Form';
import { shouldUpdateCompare } from 'utils/utils2';
import moment from 'moment';
import GetLabel from 'DisplayFramework/components/GetLabel';

const { TabPane } = Tabs;

export type TabTPStatusProps = {
  objectid?: number;
  form?: FormInstance;
  setSuccessful: any;
};

const TabTPStatus = ({ objectid, form, setSuccessful }: TabTPStatusProps) => {
  const { data, isFetching } = useQuery(
    ['getThirdPartyById', { tpid: objectid }],
    () => getThirdPartyById({ tpid: objectid! }).then((res) => res.data),
    { enabled: true }
  );
  const [rate, setrate] = useState(false);
  useEffect(() => {
    setSuccessful(isFetching);
    
  }, [isFetching]);

  return (
    <DF.Provider pagcode="TabTPStatus">
      <Row>
        <Col span={24}>
          <Tabs animated defaultActiveKey="1" type="line" >
            <TabPane tab={<GetLabel label="ChangeRating"/> } key="1" forceRender>
              <Spin spinning={isFetching} >
                <Row gutter={[8,8]}>
                  <Col xs={10}>
                    <FormInput name="tpstatustype" rules={[{ required: true }]}>
                      <ParListSelect parcode="TPSTATTYPE" onSelect={(e)=>{setrate(true)}}></ParListSelect>
                    </FormInput>
                  </Col>
                  <Col xs={10}>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tpstatustype')}
                      noStyle
                    >
                      {({ getFieldValue }) => {
                        const tspstatustype = getFieldValue('tpstatustype');
                        var currentStatus;
                        if (tspstatustype === 'STATUS') {
                          currentStatus = data?.generalData.tpstatuslabel;
                        }
                        if (tspstatustype === 'RISK') {
                          currentStatus = data?.status.tpriskstatuslabel;
                        }
                        if (tspstatustype === 'SALE') {
                          currentStatus = data?.status.tpsalestatuslabel;
                        }
                        if (tspstatustype === 'KYC') {
                          currentStatus = data?.generalData.tpkycstatuslabel;
                        }
                        if (tspstatustype === 'CLASS') {
                          currentStatus = data?.generalData.tpclasslabel;
                        }

                        return (
                          <FormInput name="tpcurrentstatus">
                            <Text>{currentStatus}</Text>
                          </FormInput>
                        );
                      }}
                    </Form.Item>
                  </Col>
                  <Col xs={10}>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tpstatustype')}
                      noStyle
                    >
                      {({ getFieldValue }) => (
                        <FormInput
                          name="tpstatustarget"
                          rules={[{ required: true }]}
                          initialValue=''
                        >
                          <ParListSelect
                            parcode={rate===false?"":"TPSTATUS"}
                            parvalueparent={getFieldValue('tpstatustype')}
                            
                            
                          ></ParListSelect>
                        </FormInput>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={10}>
                    <FormInput name="tpstatustargetdate">
                      <DatePicker defaultValue={moment()}></DatePicker>
                    </FormInput>
                  </Col>
                </Row>
              </Spin>
            </TabPane>
          </Tabs>
        </Col>
      </Row>
    </DF.Provider>
  );
};
export default TabTPStatus;
